<script>
	import {Popup} from '../../../../model/Dialog'
	import {PopupDir} from '../../../../enum'
	import PopupHeader from './PopupHeader.vue'
	
	export default {
		components: {
			PopupHeader
		},
		
		props: {
			component: {
				type: [Object, Function] //Function兼容异步模式
			},
			
			props: {
				type: [Object]
			},
			
			eventListener: {
				type: Object,
				default(){
					return {}
				}
			},
			
			dir: {
				type: String,
				default: PopupDir.TOP
			},
			
			cancel: {
				type: Boolean,
				default: true
			},
			
			title: {
				type: [String, Number],
				default: ''
			},
			
			value: {
				type: [String, Number, Boolean],
				default: ''
			},
			
			handler: {
				type: Function
			},
			
			height: {
				type: [String, Number],
				default: '90%'
			},
			
			width: {
				type: [String, Number],
				default: '100%'
			},
			
			closeHandler: {
				type: Function
			}
		},
		
		render(c){
			const {component, props: componentProps, handler, eventListener, dir} = this.$props, style = {}
			if(dir !== PopupDir.TOP){
				style.padding = 0
			}
			return c('db-row', {
				class: 'popup-wrapper',
				props: {
					valign: this.valign,
					align: this.align
				},
				style,
				on: {
					click: this.cancelHandler
				}
			}, [
				c('db-row', {
					class: ['popup-container', this.popupClass, 'dir-' + dir.toLowerCase()],
					props: {
						width: this.realWidth,
						height: this.realHeight
					},
					on: {
						click: this.wrapperClick
					}
				}, [
					c(PopupHeader, {
						props: {
							dir: this.dir,
							title: this.title,
							cancel: this.cancel
						},
						on: {
							close: this.close
						}
					}),
					c('db-row', {
						class: 'auto-fill ovh'
					}, [
						(!this.load) && c('db-row', {
							class: 'popup-loading',
							props: {
								align: 'center'
							}
						}, [
							c('db-blend-text', {
								class: ['ft-42'],
								props: {
									text: this.$config.platform.loadingText || '豆包网',
									width: '80%',
									height: '100'
								}
							})
						]),
						(this.component && this.load) ? c(component, {
							class: 'auto-fill',
							props: this.$props.props,
							on: {
								close: async (handler) => {
									console.log(3333)
									await this.close('333')
								},
								ready: () => {
									this.load = true
								},
								input: (message) => {
									this.$store.commit('mobileStore/change', message)
									handler(message)
								},
								...eventListener,
							}
						}) : null
					])
				])
			])
		},
		
		data(){
			return {
				popupClass: 'popup-init',
				load: false
			}
		},
		
		computed: {
			valign(){
				const {dir} = this.$props
				return (dir === PopupDir.TOP) ? 'bottom' : 'top'
			},
			
			align(){
				const {dir} = this.$props
				return (dir === PopupDir.RIGHT) ? 'left' : 'right'
			},
			
			realWidth(){
				const {dir, width} = this.$props
				return (dir === PopupDir.TOP || dir === PopupDir.BOTTOM) ? '100%' : width
			},
			
			realHeight(){
				const {dir, height} = this.$props
				return (dir === PopupDir.LEFT || dir === PopupDir.RIGHT) ? '100%' : height
			}
		},
		
		mounted(){
			this.start()
		},
		
		methods: {
			wrapperClick(){
				event.stopPropagation()
			},
			
			cancelHandler(){
				this.cancel && this.close()
			},
			
			async start(){
				return new Promise(res => {
					setTimeout(() => {
						this.popupClass = 'popup-active'
						setTimeout(async () => {
							this.load = true
							res()
						}, 200)
					}, 50)
				})
			},
			
			async close(){
				
				return new Promise(res => {
					this.popupClass = 'popup-init'
					setTimeout(() => {
						this.$store.commit('mobileStore/removeDialog')
						res()
						this.closeHandler && this.closeHandler()
					}, 300)
				})
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.popup-wrapper{
		background: transparent;
		padding: 16px;
		
		.popup-loading{
			margin-top: 25%;
		}
		
		.popup-container{
			background: #fff;
			overflow: hidden;
			
			&.dir-top{
				border-radius: 80px;
			}
			&.dir-bottom{
				border-radius: 0;
			}
		}
		
		.popup-init{
			transition: all .3s;
			
			&.dir-top{
				transform: translateY(100%);
			}
			&.dir-right{
				transform: translateX(-100%);
				border-radius: 0 24px 24px 0;
			}
			&.dir-bottom{
				transform: translateY(-100%);
				border-radius: 0;
			}
			&.dir-left{
				transform: translateX(100%);
				border-radius: 0;
			}
		}
		
		.popup-active{
			transition: all .3s;
			
			&.dir-top{
				transform: translateY(0);
			}
			&.dir-right{
				transform: translateX(0);
				border-radius: 0 24px 24px 0;
			}
			&.dir-bottom{
				transform: translateY(0);
			}
			&.dir-left{
				transform: translateX(0);
				border-radius: 0;
				box-shadow: 0 0 40px rgba(#000, .3);
			}
		}
	}
</style>
